/* global google */

import {startRequest} from 'common/automationUtils';

const successStatuses = ['OK'];

const biasRadiusMeters = 50000; // 50,000 meter radius, ~30 miles

function getGeocoder() {
  return google
    && google.maps
    && google.maps.Geocoder
    && new google.maps.Geocoder() || {};
}

function getAutocompleteService() {
  return google
    && google.maps
    && google.maps.places
    && google.maps.places.AutocompleteService
    && new google.maps.places.AutocompleteService() || {};
}

class PlacesService {
  constructor(options = {}) {
    this._geocoderService = options.geocoderService || getGeocoder();
    this._placesService = options.placesService || getAutocompleteService();
  }

  _formattedPlace(result) {
    const mainText = result.structured_formatting.main_text;
    const secondaryText = result.structured_formatting.secondary_text;
    return {
      name: mainText,
      address: `${mainText} ${secondaryText}`,
      secondaryText,
      position: () => new Promise((resolve, reject) => {
        const request = startRequest();
        this._geocoderService.geocode({placeId: result.place_id}, (results, status) => {
          request.end();
          if (successStatuses.indexOf(status) < 0) {
            reject(new Error(status));
          } else {
            resolve({
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng(),
            });
          }
        });
      }),
      source: 'google',
    };
  }

  geoLookup(position) {
    return new Promise((resolve, reject) => {
      if (!position || !position.lat || !position.lng) {
        reject(new Error('Invalid position.'));
      }
      this._geocoderService.geocode({
        location: new google.maps.LatLng(position),
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(results);
        } else {
          reject(new Error(status));
        }
      });
    });
  }

  searchPlaces({input, location}) {
    const payload = {input};
    if (location && location.lat && location.lng) {
      // If we are given a loction, we can use it to bias the results of the places autocomplete
      // search.  This is NOT a strict bounds and only serves to try for better results.
      payload.location = new google.maps.LatLng(location.lat, location.lng);
      payload.radius = biasRadiusMeters;
    }
    return new Promise((resolve) => {
      const request = startRequest();
      this._placesService.getPlacePredictions(payload, (results, status) => {
        request.end();
        if (successStatuses.indexOf(status) < 0) {
          // If one source fails, return no results for that source
          resolve([]);
        } else {
          resolve(results.map(this._formattedPlace.bind(this)));
        }
      });
    });
  }
}

export default PlacesService;



// WEBPACK FOOTER //
// ./src/common/services/PlacesService.js